export const thirdStepFields = [
   {name: 'email', inputName: "Email"},
   {name: 'password', inputName: "Пароль"},
 ]